<template>
  <!-- 折线图 -->
  <div :id="barChartInfo.nodeId"></div>
</template>

<script>
export default {
  name: "BarChart",
  props:["barChartInfo"],
  data(){
    return {
      // barChartInfo:{
      //     nodeId:'ageDistribution',//节点
      //     data: [20, 54, 30, 10,5,5],//数据
      //     color:["#ff5c00","#40a0fc"],
      //     xAxisData:['0-18', '18-23', '24-30', '31-40', '41-50', '50+'],
      //     min:0, //y轴的最小值
      //     max:60, //y轴最大值
      //     interval:20, //值之间的间隔
     //      yAxisName: '分数',
            //  tooltipName:'分数',
            //  unit:'分数',
            // formatter:{}//选填

      // }
    }
  },
  computed:{

  },
  methods:{
      barChart(barChartInfo){
      if(!barChartInfo.formatter){
          if(barChartInfo.unit==='%'){
              barChartInfo.formatter = function (params) {
                let vals=params[0].data+barChartInfo.unit
                return '<div>'+params[0].name+'</div><div>'+ params[0].seriesName+' : '+ vals+'</div>'
              }
          }else{
              barChartInfo.formatter = function (params) {
                let vals=params[0].data
                if(vals>=10000){
                  vals=(vals/10000).toFixed(2)+barChartInfo.unit
                }
                return '<div>'+params[0].name+'</div><div>'+ params[0].seriesName+' : '+ vals+'</div>'
                // return '<div>观看时长：'+params[0].name+'</div><div>'+ params[0].marker+' '+ params[0].seriesName+' '+ params[0].data+'</div>'
              }
          }
      }
      this.$echarts.dispose(document.getElementById(barChartInfo.nodeId));
      var myChart = this.$echarts.init(document.getElementById(barChartInfo.nodeId));


      let options = {
            tooltip : {
                trigger: 'axis',
                formatter: barChartInfo.formatter,
                // formatter: '{b0}<br/>'+barChartInfo.tooltipName+'：{c0}'+barChartInfo.unit+'',
                confine: true,//浮窗不超出屏幕范围
                textStyle: {
                    fontSize: 12,
                    color: '#333'
                },
                backgroundColor: '#fff',
                borderRadius: 4,
                axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                    type : 'line',         // 默认为直线，可选为：'line' | 'shadow'
                    lineStyle : {          // 直线指示器样式设置
                        color: '#333',
                        width: 0.2,
                        type: 'solid'
                    },
                    z: 2,//竖线在圆圈后面
                },
                extraCssText:'box-shadow:0 0 18px rgba(0,0,0,0.2)'//提示框阴影
            },
            grid: {
                x:40,
                y:40,
                x2:0,
                y2:20
            },
            xAxis: {
                type: 'category',
                // boundaryGap: false,//顶格
                data: barChartInfo.xAxisData,
                axisLine:{
                    show:true,//去除y轴线
                    lineStyle: {
                        color: '#ccc',
                        width: 0.8, //这里是为了突出显示加上的
                    }
                },
                axisLabel: {
                    textStyle: {
                        color:  '#999' , //坐标字值得具体的颜色
                    }
                },
                axisTick:{
                    show:false//去除y轴刻度
                },
            },
            yAxis: {
                type: 'value',
                scale:barChartInfo.yScale?false:true,
                name: barChartInfo.yAxisName,
                min:barChartInfo.min, //y轴的最小值
                // max:barChartInfo.max, //y轴最大值
                // interval:barChartInfo.interval, //值之间的间隔
                nameTextStyle:{
                padding:[0,0,10,-40],
                color:"#999",
                },
                splitLine:{
                    show: true,
                    lineStyle:{
                        type:'dashed',
                        color:"#ddd",
                        width:0.6
                    },
                },//去除网格线
                axisLabel:{
                    // formatter: '{value}'+ barChartInfo.unit,
                    formatter: `{value}${barChartInfo.unit || ""}`,
                        textStyle: {
                        color: '#999', //坐标值得具体的颜色
                    }
                },
                axisLine:{
                    show:false//去除y轴线
                },
                axisTick:{
                    show:false//去除y轴刻度
                },
            },
            series: [
                {
                    name: barChartInfo.yAxisName,
                    type: 'bar',
                    data: barChartInfo.data,
                    barWidth:16,//宽度
                    silent: true,
                    itemStyle: {
                        //柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
                         normal: {
                            //柱形图圆角，初始化效果
                            barBorderRadius:[15, 15, 0, 0],
                            show:true,
                            color:new this.$echarts.graphic.LinearGradient(
                                1, 0, 0, 1,
                                [
                                    {offset: 0, color: '#4faefc'},
                                    {offset: 1, color: '#187bfc'}
                                ]
                            ),
                            label: {
                                show: true,  //开启显示
                                position: 'top',  //在上方显示
                                textStyle: {  //数值样式
                                  color: '#999',
                                  fontSize: 12
                                },
                                formatter:function (params) {
                                  var txt=params.value
                                  if(txt>=10000){
                                      txt = (txt/10000).toFixed(2)+'w'
                                  }
                                  return txt
                                },
                            }
                         },
                    },
                    emphasis:{
                        itemStyle:{
                            color:"#3092fc"//高亮
                        }
                    },
                }
            ],
            axisPointer:[{
                shadowStyle:{
                    color:"rgba(255,255,255,0)"//阴影
                }
            }],
            ...barChartInfo?.customOptions  //customOptions用于自定义其余功能，如 dataZoom
        }

      myChart.setOption(options)

    }
  },
  components:{

  },
  watch:{

  },
  mounted() {
    // this.barChart(this.barChartInfo)
  }
}
</script>

<style scoped>


</style>